/**
 * Component for categorie web at header, desktop version.
 * It may be more than one, e.g. desktop and mobile
 */

import axios from 'axios';

import globalEventsService from '../services/global-events.service';

/* Component class */
const componentClass = 'component-header-categories-web-mobile';

/* How many levels */
const nLevels = 3;


function init ()
{
    const jqWrappers = $('.' + componentClass);
    jqWrappers.each(function () {
        initOne ($(this));
    });
}

function initOne (jqWrapper)
{
    /* Init begins */

    /* Init vars */
    const requestUrlPattern = jqWrapper.data('request-url-pattern');

    /* Set initial events */
    bindFixedEvents();
    bindLevelEvents(1);

    /* Init ends */

    function bindFixedEvents ()
    {
        globalEventsService.addEventListener(
            globalEventsService.EVENT_MOBILE_MENU_CLOSE,
            (event) => {
                reset();
            });
    }

    function bindLevelEvents (level) {
        const jqLevelWrapper = getLevelWrapper(level);
        jqLevelWrapper.find('a').on('click', function (event) {
            const idCategoria = $(this).data('id_categoria');
            let jqActiveEl = $(this).parent('li');
            if (jqActiveEl.length == 0) jqActiveEl = $(this).parent().parent('li');
            if (jqActiveEl.hasClass('active')) {
                setActiveElement(jqLevelWrapper, null);
                jqActiveEl.find('ul').remove();
            } else {
                setActiveElement(jqLevelWrapper, jqActiveEl);
                loadCategoriesWeb(idCategoria, level + 1, jqActiveEl);
            }
        });
    }

    function loadCategoriesWeb (idCategoriaParent, level, jqActiveEl)
    {
        if (level > 1) {
            const jqLevelWrapperParent = getLevelWrapper(level - 1);
            /* Primer esborrem el nivell, posant un loading discret */
            jqActiveEl.addClass('loading');
            /* Ara fem la consulta */
            axios.get(requestUrlPattern
                .replace(encodeURI('<id_categoria_parent>'), idCategoriaParent)
                .replace(encodeURI('<level>'), level))
            .then((response) => {
                /* Busquem element actiu del level - 1 */
                jqLevelWrapperParent.find('li ul').remove();
                jqActiveEl.removeClass('loading').append(response.data);
                jqActiveEl.find('ul').show();
                if (level < nLevels) {
                    bindLevelEvents(level);
                } else {
                    jqActiveEl.find('ul .icon-ka').remove();
                }
            });
        }
    }

    function setActiveElement(jqElementWrapper, jqElement) {
        jqElementWrapper.find('li').removeClass('active').find('.icon-ka').removeClass('active');
        if (jqElement !== null) {
            jqElement.addClass('active').find('.icon-ka').addClass('active');
        }
    }

    function reset ()
    {
        for (let levelIt = 1; levelIt <= nLevels; levelIt++) {
            if (jqLevelWrappers[levelIt] !== undefined) {
                jqLevelWrappers[levelIt].removeClass('loading')
                    .find('li').removeClass('active');
                if (levelIt > 1) {
                    jqLevelWrappers[levelIt].html('');
                }
            } else {
                if (levelIt > 1) {
                    jqWrapper.find('.categoria-web-level-'+(levelIt-1).toString()).find('li ul').remove();
                }
            }
        }
    }

    function getLevelWrapper (level)
    {
        return jqWrapper.find('ul.categoria-web-level-'+level.toString())
    }

}

export default {
    componentClass,
    init,
};
